module.exports = __webpack_public_path__ + "media/theme/banner___top--cards-d4fe99fb.png";